import { Fragment, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import { BellIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import ShowIf from "../show-if/ShowIf";
import { showApiErrorMessages } from "../../helpers";
import { useLocation } from "react-router-dom";
import NotificationCard from "./NotificationCard";
import TabsComponent from "../tabs/TabsComponent";
import { useQuery } from "react-query";
import {
  indexNotifications,
  indexStudentNotifications,
  indexTutorNotifications,
  setNotificationViewed,
  setNotificationViewedStudent,
  setNotificationViewedTutor,
} from "../../api/endpoints/notifications";
import { NotificationsType } from "../../api/@types/globalTypes";
import { useAuth } from "../../context/AuthContext";

export default function NotificationMenu() {
  const { t } = useTranslation("", {
    keyPrefix: "page.chat",
  });
  const { currentUser, userType }: any = useAuth();

  const { pathname: currentPath } = useLocation();
  const [unreadNotification, setUnreadNotification] = useState<boolean>(true);
  const { data: notifications, refetch } = useQuery(
    ["notifications"],
    () => {
      if (currentUser?.object_type?.toLowerCase() === "supervisor") {
        return indexNotifications();
      }
      if (currentUser?.object_type?.toLowerCase() === "tutor") {
        return indexTutorNotifications();
      }
      return indexStudentNotifications();
    },
    {
      select: (response) => {
        let fetchNotifications = [];
        let unReadNotifications = [];
        if (response.isSuccess) {
          fetchNotifications = response.data;
          unReadNotifications = response.data.filter(
            (db: NotificationsType) =>
              (!db?.seen_by_supervisor_id && userType === "supervisor") ||
              (!db?.seen && userType !== "supervisor")
          );
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return {
          data: fetchNotifications,
          paginationInfo,
          unReadNotifications,
        };
      },
    }
  );
  const changeNotificationViewed = async (id: string | number) => {
    if (!!id) {
      let response: any;
      if (currentUser?.object_type?.toLowerCase() === "supervisor") {
        response = await setNotificationViewed([id]);
      } else if (currentUser?.object_type?.toLowerCase() === "tutor") {
        response = await setNotificationViewedTutor([id]);
      } else {
        response = await setNotificationViewedStudent([id]);
      }
      if (!!response.isSuccess) {
        refetch();
      }
    }
  };

  const tabs = [
    {
      name: t("all"),
      content: (
        <div className="w-full h-full overflow-y-auto">
          {notifications?.data?.length > 0 &&
            notifications?.data?.map((notification: NotificationsType) => (
              <NotificationCard
                onClick={(id: string | number) => changeNotificationViewed(id)}
                notification={notification}
                key={notification.id}
              />
            ))}
        </div>
      ),
    },
    {
      name: t("unread"),
      content: (
        <div className="w-full">
          {notifications?.unReadNotifications?.length > 0 &&
            notifications?.unReadNotifications?.map(
              (notification: NotificationsType) => (
                <NotificationCard
                  onClick={(id: string | number) =>
                    changeNotificationViewed(id)
                  }
                  notification={notification}
                  key={notification.id}
                />
              )
            )}
        </div>
      ),
    },
  ];
  return (
    <Popover className="relative z-[9999] ">
      {({ open }) => (
        <>
          <Popover.Button className="relative inline-flex items-center focus:outline-none">
            <BellIcon className="flex w-6 h-6 text-gray-400" />
            <ShowIf condition={!!notifications?.unReadNotifications?.length}>
              <div
                key={"unreadMessagesCounter"}
                className="absolute inline-flex items-center justify-center w-2.5 h-2.5 text-xs font-bold text-white bg-red-600   rounded-full -top-0.5 -right-0"
              />
            </ShowIf>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
            show={open}
          >
            <Popover.Panel className="absolute   block max-h-[544px]  ltr:translate-x-[-45%] lrt:-left-full  ltr:md:translate-x-0   rtl:md:translate-x-0   rtl:translate-x-[37%]   rtl:-right-full md:rtl:right-1/2 md:ltr:left-1/2 z-10 mt-9 w-screen max-w-sm md:max-w-md px-2 sm:px-0">
              {({ close }) => (
                <div className="flex flex-col justify-between h-full overflow-hidden bg-white md:justify-start md:rounded-md md:shadow-lg">
                  <div className="px-6 py-4 flex flex-col  w-full  max-h-[544px] overflow-auto  h-full">
                    <div className="mt-2 mb-4">
                      <h1 className="text-xl font-medium text-gray-800 ">
                        {t("notifications")}
                      </h1>
                    </div>
                    <TabsComponent
                      stickyPosition={true}
                      defaultTab={0}
                      tabs={tabs}
                    />
                  </div>
                  <div className="sticky bg-white  mt-auto z-[999] w-full  bottom-0  flex justify-center items-center  px-4 pt-4 pb-6 md:px-6">
                    {/* <button
                      type="button"
                      onClick={() => {
                        close();
                      }}
                      className="flex items-center justify-center w-full py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow h-9 md:border-none md:shadow-none"
                    >
                      {t("moreNotifications")}
                    </button> */}
                  </div>
                </div>
              )}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
